import "./bootstrap";
import { Livewire, Alpine } from "../../vendor/livewire/livewire/dist/livewire.esm.js";
import focus from "@alpinejs/focus";
import Mapbox from "./Mapbox";
import buildingMapSearch from './Components/BuildingMapSearch';
import salesMapSearch from './Components/SalesMapSearch';
import carousel from './Components/Carousel';
import ImageZoom from './Plugins/ImageZoom';


// Inicializar Mapbox globalmente
window.Mapbox = new Mapbox(import.meta.env.VITE_RADAR_PUBLISHABLE_KEY || import.meta.env.VITE_MAPTILER_TOKEN);

window.buildingMapSearch = buildingMapSearch;
window.salesMapSearch = salesMapSearch;

import {LightGallery} from './LightGallery.js'
import buildingPage from "./portal_assetplan/pages/building-page.js";
import { nearbyPlacesAccordion } from "./portal_assetplan/components/nearby-places-accordion.js";

if (!customElements.get('light-gallery')) {
    customElements.define('light-gallery', LightGallery);
}

// Creamos la instancia global
window.lightGalleryInstance = document.createElement('light-gallery');

Alpine.plugin(ImageZoom);

// Registrar el page
Alpine.data("buildingPage", buildingPage);

// Registrar nearbyPlacesAccordion module
Alpine.data("nearbyPlacesAccordion", nearbyPlacesAccordion);

// Registrar componente carousel
Alpine.data('carousel', carousel);

// Registrar componente focus
Alpine.plugin(focus);

// Hacer Alpine disponible globalmente
window.Alpine = Alpine;

// Stub de feature flags disponible desde el inicio.
// Acumula callbacks de onReady hasta que el provider real esté listo.
// Así los componentes pueden llamar onReady() en cualquier momento sin depender
// del orden de inicialización — igual que analytics funciona con acciones de usuario.
window.assetplanFlags = {
    _queue: [],
    onReady(cb) { this._queue.push(cb); },
    isEnabled() { return false; },
    getVariant(flag) { return flag.CONTROL; },
};

// Livewire v3 inicializa Alpine, así evitamos dos instancias distintas.
Livewire.start();

window.dataLayer = window.dataLayer || [];
function gtag(){
    dataLayer.push(arguments);
}

window.addEventListener("sendDataLayerCustomEvent", function (event) {
    window.dataLayerCustomEvent(event.detail.name, event.detail.payload);
});

window.dataLayerCustomEvent = function (customName, payload) {
    gtag('event', customName, payload);
};

window.successUrl = function (customName, path) {
    gtag('event', customName, {
        page_location: import.meta.env.VITE_URL+ path,
        page_path: path,
        page_title: document.title
    });
};

window.pageViewUrl = function (path) {
    gtag('event', 'page_view', {
        page_location: import.meta.env.VITE_URL+ path,
        page_path: path,
        page_title: document.title
    });
}

import { createScopedAnalytics } from '@assetplan/analytics-kit';
import { bootstrapSitioWebAnalytics, bootstrapConsoleAnalytics, bootstrapFeatureFlags } from './bootstrap-analytics';

const isProduction = import.meta.env.VITE_ENVIRONMENT === 'production';

const analytics = createScopedAnalytics({
    sitio_web: isProduction ? bootstrapSitioWebAnalytics : bootstrapConsoleAnalytics,
})

// start automatic tracking
analytics.init('sitio_web')

window.assetplanAnalytics = analytics;

// Reemplazar el stub con el provider real y ejecutar los callbacks que se hayan acumulado.
const realFlags = bootstrapFeatureFlags(isProduction);
const queuedCallbacks = window.assetplanFlags._queue;
window.assetplanFlags = realFlags;
realFlags._initialized = true;
queuedCallbacks.forEach(cb => realFlags.onReady(cb));
